export default __webpack_public_path__ + "static/media/selfImg.26e4291e.jpg";